import { CustomSpaceFields } from '@tribeplatform/gql-client/graphql/space'

import { StaticField, View } from '../../Views/types'

interface GenerateActiveFieldIds {
  staticFields: StaticField[]
  style: View['style']
}
const getActiveFields = ({
  staticFields,
  style,
}: GenerateActiveFieldIds): StaticField[] => {
  let output: StaticField[] = []
  staticFields
    .filter(
      ({ enabled, styles, isStatic }) =>
        enabled && isStatic && !(styles && !styles.includes(style)),
    )
    .forEach(field => {
      output = [...output, field]

      if (field?.fields) {
        output = [
          ...output,
          ...getActiveFields({ staticFields: field.fields, style }),
        ]
      }
    })

  return output
}

interface Props {
  staticFields: StaticField[]
  style: View['style']
}
export const generateGqlFields = ({
  staticFields,
  style,
}: Props): CustomSpaceFields => {
  const activeFields = getActiveFields({ staticFields, style })

  const spaceFields = activeFields.reduce((prev, field) => {
    switch (field.id) {
      case 'listImage':
      case 'galleryBanner':
      case 'cardBanner':
        return { ...prev, image: 'basic', banner: 'basic' } as CustomSpaceFields
      case 'postsCount':
        return { ...prev, postsCount: 'basic' } as CustomSpaceFields
      case 'joinButton':
        return {
          ...prev,
          authMemberProps: { permissions: 'basic' },
        } as CustomSpaceFields
      default:
        return prev
    }
  }, {} as CustomSpaceFields)

  return spaceFields
}
